import { useApolloClient } from '@apollo/client/react';
import { Formik } from 'formik';
import NewLinkInviteForm, { newLinkInviteSchema } from '../new-link-invite-form';
import { createEventLinkInviteMutation, eventInvitesQuery } from '../../apollo/events';
import type { Event } from '../../types/Event';

type Props = {
  event?: Event;
  disabled?: boolean;
};

const NewEventLinkInvite = ({ event, disabled }: Props) => {
  const client = useApolloClient();
  return (
    <Formik
      initialValues={{}}
      validationSchema={newLinkInviteSchema}
      onSubmit={(values, actions) => {
        client.mutate({
          mutation: createEventLinkInviteMutation,
          variables: { eventId: event.id },
          update: (proxy, { data: { createEventLinkInvite: newInvite } }) => {
            const listVariables = { id: event.id };
            const data = proxy.readQuery({
              query: eventInvitesQuery,
              variables: listVariables
            })
            proxy.writeQuery({
              query: eventInvitesQuery,
              data: {
                ...data,
                event: {
                  ...data.event,
                  linkInvites: [newInvite, ...data.event.linkInvites]
                }
              },
              variables: listVariables
            })
          }
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          actions.setSubmitting(false);
          console.log(error);
          // actions.setErrors();
          // actions.setStatus();
        });
      }}
    >
      <NewLinkInviteForm disabled={disabled} />
    </Formik>
  );
}

export default NewEventLinkInvite;
